angular.module('gym.subscriptions').controller('ConfirmPlanChangeModalCtrl', ["$scope", "$modalInstance", "currentPlan", "newPlan", "warnings", function($scope, $modalInstance, currentPlan, newPlan, warnings) {
  $scope.currentPlan = currentPlan;
  $scope.newPlan = newPlan;
  $scope.warnings = [];
  if (warnings.indexOf('deactivate_booking_settings') >= 0) {
    $scope.warnings = ['The ability to restrict how late a booking can be made, before the event starts', 'The ability to restrict how late a booking can be cancelled, before the event starts'];
  }
  $scope.confirm = function() {
    return $modalInstance.close();
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
